<div class="spinner-wrapper">
    <!--<mdb-spinner spinnerType="big" spinnerColor="blue"></mdb-spinner>-->

    <div class="spinner-border grey-text" style="width: 5rem; height: 5rem;" role="status">
      <!-- <span class="sr-only">Loading...</span> -->
    </div>
  </div>
